import React, {useContext,useEffect,useRef,useState} from 'react'
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import {JourneyContext} from "../context/journeyContext"
import { Swiper, SwiperSlide } from "swiper/react"
import { getValueFromJourney, isEquitasChannel } from '../services/helperFunctions'
import { lineCapital } from '../../shared/functions'
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
SwiperCore.use([Navigation])

const getHrefFromAnchorTag = (anchorTag = "") => {
  const lowerAnchorTag = anchorTag.toLowerCase()
  const hrefIdx = lowerAnchorTag.indexOf("href")
  if (hrefIdx < 0) return ""

  let idx = hrefIdx + 4
  while (idx < anchorTag.length && /\s/.test(anchorTag[idx])) idx += 1
  if (anchorTag[idx] !== "=") return ""

  idx += 1
  while (idx < anchorTag.length && /\s/.test(anchorTag[idx])) idx += 1
  if (idx >= anchorTag.length) return ""

  const quote = anchorTag[idx]
  if (quote === '"' || quote === "'") {
    const endQuoteIdx = anchorTag.indexOf(quote, idx + 1)
    return endQuoteIdx < 0 ? "" : anchorTag.slice(idx + 1, endQuoteIdx)
  }

  let endIdx = idx
  while (endIdx < anchorTag.length && !/\s|>/.test(anchorTag[endIdx])) endIdx += 1
  return anchorTag.slice(idx, endIdx)
}

const transformEquitasAnchorHtml = (sourceHtml = "") => {
  const closeTag = "</a>"
  const lowerHtml = sourceHtml.toLowerCase()
  let cursor = 0
  let transformed = ""

  while (cursor < sourceHtml.length) {
    const openIdx = lowerHtml.indexOf("<a", cursor)
    if (openIdx < 0) {
      transformed += sourceHtml.slice(cursor)
      break
    }

    const openTagEndIdx = sourceHtml.indexOf(">", openIdx + 2)
    if (openTagEndIdx < 0) {
      transformed += sourceHtml.slice(cursor)
      break
    }

    const anchorTag = sourceHtml.slice(openIdx, openTagEndIdx + 1)
    const hrefValue = getHrefFromAnchorTag(anchorTag)
    if (!hrefValue) {
      transformed += sourceHtml.slice(cursor, openTagEndIdx + 1)
      cursor = openTagEndIdx + 1
      continue
    }

    const closeIdx = lowerHtml.indexOf(closeTag, openTagEndIdx + 1)
    if (closeIdx < 0) {
      transformed += sourceHtml.slice(cursor)
      break
    }

    const inner = sourceHtml.slice(openTagEndIdx + 1, closeIdx)
    transformed += sourceHtml.slice(cursor, openIdx)
    transformed += `<span>${inner}</span> <span data-copy-url="${hrefValue}" style="cursor: pointer; text-decoration: underline; color: #0d6efd;">(click to copy url)</span>`
    cursor = closeIdx + closeTag.length
  }

  return transformed
}

export default function ComponentCheckbox(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [checked, setChecked] = useState(false);
  const copyTimeoutRef = useRef(null)
  const copyElementRef = useRef(null)

  useEffect(() => {
    if (!sectionState.sectionData?.[props.data.formControlKey]) {
        if (props.data.isChecked) {
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: props.data.isChecked,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: props.data.isChecked,
                },
              }
            })
          }
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.isChecked,
            }
          })
        }
     
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
        }
      })
    }
  }, [])

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current)
      }
    }
  }, [])

  const validate = (target, nextValue = null) =>  {
    const resolvedValue =
      nextValue !== null
        ? nextValue
        : sectionState.sectionData?.[props.data.formControlKey]
    if(props.data.required){ // required field validation
      if((resolvedValue === "") || (!resolvedValue)){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
            ? (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            )): `Error Code Not Found in Strapi`,
          })
        })
      }else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      // if(target.value){
      //   setErrorState(prev => {
      //     return({
      //       ...prev,
      //       [props.data.formControlKey]: ""
      //     })
      //   })
      // }
    }
    return
  }

  useEffect(()=>{
    validate({value: sectionState.sectionData?.[props.data.formControlKey]?? ""})
  },[sectionState.sectionData?.[props.data.formControlKey]])

  const handleChange = target => {
    const nextValue = sectionState.sectionData[props.data.formControlKey]
      ? !sectionState.sectionData[props.data.formControlKey]
      : true
    if (nextValue) {
      setErrorState(prev => ({
        ...prev,
        [props.data.formControlKey]: "",
      }))
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: nextValue 
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: nextValue 
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: nextValue 
      }
    })
    validate(target, nextValue)
  }

  const handleContentClick = async (event) => {
    const copyTarget = event?.target
    const copyUrl = copyTarget?.dataset?.copyUrl
    if (!copyUrl) return

    let isCopied = false
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(copyUrl)
        isCopied = true
      }
    } catch (error) {}

    if (!isCopied) {
      const textarea = document.createElement("textarea")
      textarea.value = copyUrl
      document.body.appendChild(textarea)
      textarea.select()
      isCopied = document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    if (!isCopied) return

    const defaultLabel = "(click to copy url)"
    if (copyElementRef.current && copyElementRef.current !== copyTarget) {
      copyElementRef.current.textContent = defaultLabel
    }

    copyTarget.textContent = "(copied)"
    copyElementRef.current = copyTarget

    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current)
    }

    copyTimeoutRef.current = setTimeout(() => {
      if (copyElementRef.current) {
        copyElementRef.current.textContent = defaultLabel
        copyElementRef.current = null
      }
    }, 2000)
  }

  let htmlContent = props.data?.html || ""
  if (isEquitasChannel(props.channel) && htmlContent) {
    htmlContent = transformEquitasAnchorHtml(htmlContent)
  }
  return (
    <>
      <div style={{overflow: "hidden", width: "100%"}}>
        <input
          type="checkbox"
          style={{
            width: "25px",
            height: "25px",
            display: "block",
            float: "left"
          }}
          checked={sectionState?.sectionData[props.data.formControlKey]}
          onChange={handleChange}
        />
        <div
          dangerouslySetInnerHTML={{ "__html": htmlContent }}
          onClick={handleContentClick}
          style={{display: "block", float: "right", width: "calc(100% - 50px)"}}
        ></div>
      </div>

      <span className="input-error2" style={{marginLeft: "50px"}}>
        {props.showError && errorState[props.data.formControlKey]}
      </span>
    </>
  )

}
